import angular from 'angular'
import dataSourceConfigCtrl from './dataSourceConfigCtrl'


import {
    externalSystem
} from 'redevConfig'


const list = (externalSystem && externalSystem.list) || ''
const add = (externalSystem && externalSystem.add) || ''

const listCtrl = list ? require(`redevelopment/system/externalSystem/${list.controllerName}`) : require('./list')
const listPage = list ? require(`redevelopment/system/externalSystem/${list.templateName}`) : require('./views/list.html')

const edit = add ? require(`redevelopment/system/externalSystem/${add.controllerName}`) : require('./edit')
const editPage = add ? require(`redevelopment/system/externalSystem/${add.templateName}`) : require('./views/edit.html')

function config($stateProvider) {
    $stateProvider
        .state('system.settingcenter.externalSystem', {
            url: '/externalSystem',
            template: '<div ui-view></div>',
            title: '外部对接系统',
            abstract: true,
            default: 'system.settingcenter.externalSystem.list',
        })
        .state('system.settingcenter.externalSystem.list', {
            url: '/list',
            controller: 'externalSystemlistCtrl',
            template: listPage,
        })
        .state('system.settingcenter.externalSystem.add', {
            url: '/add',
            controller: 'editExternalSystemCtrl',
            template: editPage,
            title: '新增',
        })
        .state('system.settingcenter.externalSystem.edit', {
            url: '/edit/:clientId',
            controller: 'editExternalSystemCtrl',
            template: editPage,
            title: '编辑',
        })
}
export default angular
    .module('system.settingcenter.externalSystem', [])
    .config(['$stateProvider', config])
    .controller('externalSystemlistCtrl', listCtrl.default)
    .controller('editExternalSystemCtrl', edit.default)
    .controller('dataSourceConfigCtrl', dataSourceConfigCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/externalSystem/index.js